export default {
  product_unit: {
    liter: "ลิตร",
    piece: "ชิ้น",
    bottle: "ขวด",
    box: "กล่อง",
    grams: "กรัม",
    meter: "เมตร",
    gallon: "แกลลอน",
    can: "กระป๋อง",
    basket: "ตระกร้า",
    roll: "ม้วน",
    set: "เซ็ต",
    kilograms: "กิโลกรัม",
    bag: "ถุง",
    pack: "ซอง",
    set: "ชุด",
    machine: "เครื่อง",
    tube: "เส้น",
    tube_2: "หลอด",
    couple: "คู่",
    crate: "ลัง",
    bottle_250_liter: "ขวด (0.25 ลิตร)",
    bottle_500_liter: "ขวด (0.5 ลิตร)",
    bag_450_grams: "ถุง (450 กรัม)",
    bottle_250_grams: "ขวด (250 กรัม)",
    copy: "เล่ม",
    bucket: "ถัง",
    package: "แพ็ค",
    bowl: "กระปุก",
    dozen: "โหล",
    handle: "ด้าม",
    bottle_100_liter: "ขวด (0.1 ลิตร)",
    time: "ครั้ง",
  }
};


// WEBPACK FOOTER //
// ./src/const/const.js